$(function () {
    $(document).on('click', '.dialog-close-btn', function () {
        // セッションストレージに保存
        sessionStorage.setItem('medical_personnel', true);
        
        // ダイアログを閉じる
        common.closeDialog();
    });
});